// import SAMPLE_WEEKLY_REFLECTION_RESPONSE from './__mocks__/sample-weekly-reflection-response.json'
import {
  V2_PERFORMANCE_REFLECTION_DETAIL,
  V2_PERFORMANCE_REFLECTION_TERMS,
} from '../graphql/queries/performanceReflection'

import {
  V2_PERFORMANCE_LIST_CHECKLIST_EVALUATIONS,
  V2_PERFORMANCE_LIST_FRAMEWORKS,
  V2_PERFORMANCE_LIST_CHECKLIST_EVALUATION_DETAIL,
  V2_ADMIN_PERFORMANCE_CHECKLIST_EVALUATIONS,
  V2_ADMIN_PERFORMANCE_CHECKLIST_EVALUATION,
  V2_PERFORMANCE_GET_FRAMEWORK_DETAIL,
  V2_PERFORMANCE_EXPORT_CHECKLIST,
} from '~/graphql/queries/performance'

import {
  V2_PERFORMANCE_REFLECTIONS,
  V2_PERFORMANCE_REFLECTION_PROFILES,
  V2_PERFORMANCE_REFLECTION_PROFILE,
} from '~/graphql/queries/performanceReflection'

import {
  V2_PERFORMANCE_UPDATE_CHECKLIST_EVALUATION_STATUS,
  V2_PERFORMANCE_UPDATE_CHECKLIST_RECORD,
  V2_PERFORMANCE_CREATE_COMMENT,
  V2_PERFORMANCE_UPDATE_COMMENT,
  V2_PERFORMANCE_UNASSIGN_CHECKLIST,
  V2_PERFORMANCE_BULK_UPDATE_CHECKLIST_EVALUATION_STATUS,
  V2_PERFORMANCE_EVALUATIONS_TAKE_ACTION,
  V2_PERFORMANCE_CREATE_CONVERSATION,
  V2_PERFORMANCE_UPDATE_CONVERSATION,
  V2_PERFORMANCE_CREATE_CHECKLIST_EXPECTATION,
  V2_PERFORMANCE_UPDATE_CHECKLIST_EXPECTATION,
  V2_PERFORMANCE_CREATE_CHECKLIST,
  V2_PERFORMANCE_UPDATE_CHECKLIST,
  V2_PERFORMANCE_CHECKLIST_ASSIGN_STAFFS,
  V2_ADMIN_PERFORMANCE_DELETE_FRAMEWORK,
} from '~/graphql/mutations/performance'

const OPTIONS = {
  development_goal_categories_cn: [
    {
      value: '工作表现评估',
      label: '工作表现评估',
    },
    {
      value: '职员兴趣与长处',
      label: '职员兴趣与长处',
    },
    {
      value: '职员职业发展',
      label: '职员职业发展',
    },
    {
      value: '机构的关注点',
      label: '机构的关注点',
    },
    {
      value: '中心的策略计划',
      label: '中心的策略计划',
    },
    {
      value: '学前教育（ECDA）部门需求',
      label: '学前教育（ECDA）部门需求',
    },
    {
      value: '学前教育（ECDA）部门所推广的培训',
      label: '学前教育（ECDA）部门所推广的培训',
    },
    {
      value: '其他',
      label: '其他',
    },
  ],
  development_goal_categories: [
    {
      value: 'Performance Review Rating',
      label: 'Performance Review Rating',
    },
    {
      value: 'Staff’s interests and strengths',
      label: 'Staff’s interests and strengths',
    },
    {
      value: 'Career progression for staff',
      label: 'Career progression for staff',
    },
    {
      value: 'Organisation’s emphasis',
      label: 'Organisation’s emphasis',
    },
    {
      value: 'Centre’s strategic plan',
      label: 'Centre’s strategic plan',
    },
    {
      value: 'Sector requirement',
      label: 'Sector requirement',
    },
    {
      value: 'Sector initiatives',
      label: 'Sector initiatives',
    },
    {
      value: 'Other',
      label: 'Other',
    },
  ],
  strengths: [
    {
      value: 'Strength A',
      label: 'Strength A',
    },
    {
      value: 'Strength B',
      label: 'Strength B',
    },
  ],
}

export function getAppraisalRecordsV2(apolloClient, params) {
  let QUERY = V2_PERFORMANCE_LIST_CHECKLIST_EVALUATIONS

  if (params.evaluationType === 'WEEKLY_REFLECTION') {
    QUERY = V2_PERFORMANCE_REFLECTIONS
  }

  return apolloClient
    .query({
      query: QUERY,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceGetChecklistEvaluations)
}

export function getAppraisalProfilesV2(apolloClient, params) {
  const QUERY = V2_PERFORMANCE_REFLECTION_PROFILES

  return apolloClient
    .query({
      query: QUERY,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceGetEvaluationProfiles)
}

export function getAppraisalProfileV2(apolloClient, params) {
  const QUERY = V2_PERFORMANCE_REFLECTION_PROFILE

  return apolloClient
    .query({
      query: QUERY,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceGetEvaluationProfile)
}

export function getPerformanceTermsV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_PERFORMANCE_REFLECTION_TERMS,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceGetTerms)
}

export function getAppraisalDetailV2(apolloClient, params) {
  let QUERY = V2_PERFORMANCE_LIST_CHECKLIST_EVALUATION_DETAIL

  if (params.evaluationType === 'WEEKLY_REFLECTION') {
    QUERY = V2_PERFORMANCE_REFLECTION_DETAIL
  }
  return apolloClient
    .query({
      query: QUERY,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => {
      return res.data.v2PerformanceGetChecklistEvaluationDetail
    })
}

export function createPerformanceCommentV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_PERFORMANCE_CREATE_COMMENT,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceCreateComment)
}

export function updatePerformanceCommentV2(apolloClient, params) {
  // Sanitize the params to ensure comment is a string
  const sanitizedParams = {
    ...params,
    comment: typeof params.comment === 'string' ? params.comment : '',
  }

  return apolloClient
    .query({
      query: V2_PERFORMANCE_UPDATE_COMMENT,
      variables: sanitizedParams,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceUpdateComment)
}

export function updateCommentInChecklistRecordItem(apolloClient, params) {
  // return axios.put('https://29e48d89-0871-4503-8395-5fcca49e12fb.mock.pstmn.io/appraisals/1/checklist-item-record/1/comments/1').then(res => res.data)
  return Promise.resolve(true)
}
export function deleteCommentInChecklistRecordItem(apolloClient, params) {
  return Promise.resolve(true)
  // return axios.delete('https://29e48d89-0871-4503-8395-5fcca49e12fb.mock.pstmn.io/appraisals/1/checklist-item-record/1/comments/1').then(res => res.data)
}

export function getOptions(optionsId) {
  return Promise.resolve(OPTIONS[optionsId] || [])
}

export function updateChecklistRecord(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_UPDATE_CHECKLIST_RECORD,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceUpdateChecklistRecord)
}

export function updateChecklistEvaluation(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_UPDATE_CHECKLIST_EVALUATION_STATUS,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceUpdateChecklistEvaluationStatus)
}

export function getListFrameworksV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_PERFORMANCE_LIST_FRAMEWORKS,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceListFrameworks)
}

export function getAdminEvaluationsV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_ADMIN_PERFORMANCE_CHECKLIST_EVALUATIONS,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2AdminPerformanceGetChecklistEvaluations)
}

export function getAdminEvaluationDetailV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_ADMIN_PERFORMANCE_CHECKLIST_EVALUATION,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2AdminPerformanceGetChecklistEvaluationDetail)
}

export function updateChecklistV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_UPDATE_CHECKLIST,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceUpdateChecklist)
}

export function getFrameworkDetailV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_PERFORMANCE_GET_FRAMEWORK_DETAIL,
      variables: params,
      fetchPolicy: 'network-only',
    })
    .then((res) => res.data.v2PerformanceGetFrameworkDetail)
}

export function unassignChecklist(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_UNASSIGN_CHECKLIST,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceChecklistAssignRemoveStaffs)
}

export function bulkUpdateChecklistEvaluationStatusV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_BULK_UPDATE_CHECKLIST_EVALUATION_STATUS,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceBulkUpdateChecklistEvaluationStatus)
}

export function takeActionAppraisalV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_EVALUATIONS_TAKE_ACTION,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceEvaluationsTakeAction)
}

export function createPerformanceConversationV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_CREATE_CONVERSATION,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceCreateConversation)
}

export function updatePerformanceConversationV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_UPDATE_CONVERSATION,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceUpdateConversation)
}

export function createPerformanceExpectationV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_CREATE_CHECKLIST_EXPECTATION,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceCreateChecklistExpectation)
}

export function updatePerformanceExpectationV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_UPDATE_CHECKLIST_EXPECTATION,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceCreateChecklistExpectation)
}

export function exportPerformanceTemplateV2(apolloClient, params) {
  return apolloClient
    .query({
      query: V2_PERFORMANCE_EXPORT_CHECKLIST,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceExportChecklist)
}

export function createPerformanceChecklistV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_CREATE_CHECKLIST,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2PerformanceCreateChecklist)
}

export function assignPerformanceChecklistV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_PERFORMANCE_CHECKLIST_ASSIGN_STAFFS,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data)
}

export function deleteFrameworkV2(apolloClient, params) {
  return apolloClient
    .mutate({
      mutation: V2_ADMIN_PERFORMANCE_DELETE_FRAMEWORK,
      variables: params,
      fetchPolicy: 'no-cache',
    })
    .then((res) => res.data.v2AdminPerformanceDeleteFramework)
}
